export default "__VITE_ASSET__Dy2u_qrT__"